import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PlaneIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
export function AirportsPage() {
  const airports = [{
    name: 'Halim Perdanakusuma',
    code: 'HLP',
    city: 'Jakarta',
    region: 'DKI Jakarta',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q1mVx9c4yNGVBqTdg9z6Bo/Bandara_Halim_Perdanakusuma.jpg'
  }, {
    name: 'Bersujud',
    code: 'BTW',
    city: 'Batulicin',
    region: 'Kalimantan Selatan',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uczKEzheTShgXYQ4BnDEBj/IMG-20250814-WA0127-960x540.jpg'
  }, {
    name: 'Syamsudin Noor',
    code: 'BDJ',
    city: 'Banjarbaru',
    region: 'Kalimantan Selatan',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9c5vNMJtMWMAKA3BibF8CZ/IMG-20230603-WA0248.png'
  }, {
    name: 'Sultan Hasanuddin',
    code: 'UPG',
    city: 'Makassar',
    region: 'Sulawesi Selatan',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4jhrA5mz3mKK9APr6YMq6X/peM7xG_sultan20hasanuddin.webp'
  }];
  return <div className="w-full" data-id="element-152">
      <Helmet data-id="element-153">
        <title data-id="element-154">
          Bandara Operasional - PT Jagat Indo Perkasa | HLP Jakarta, BTW
          Batulicin, BDJ Banjarbaru, UPG Makassar
        </title>
        <meta name="description" content="PT Jagat Indo Perkasa melayani 4 bandara strategis di Indonesia dengan layanan ground handling lengkap 24/7: Bandara Halim Perdanakusuma (HLP) Jakarta, Bandara Bersujud (BTW) Batulicin Kalimantan Selatan, Bandara Syamsudin Noor (BDJ) Banjarbaru Kalimantan Selatan, dan Bandara Sultan Hasanuddin (UPG) Makassar Sulawesi Selatan. Ramp handling, passenger service, cargo handling, dan flight support profesional." data-id="element-155" />
        <meta name="keywords" content="ground handling Halim Perdanakusuma, ground handling Jakarta HLP, ground handling Batulicin BTW, ground handling Banjarbaru BDJ, ground handling Makassar UPG, bandara operasional PT Jagat Indo Perkasa, layanan bandara Jakarta, layanan bandara Kalimantan, layanan bandara Sulawesi, ground handling 24/7" data-id="element-156" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-157" />
        <meta name="robots" content="index, follow" data-id="element-158" />
        <link rel="canonical" href="https://jagatindoperkasa.id/airports" data-id="element-159" />
        <meta name="geo.region" content="ID" data-id="element-160" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-161" />
        <meta property="og:url" content="https://jagatindoperkasa.id/airports" data-id="element-162" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-163" />
        <meta property="og:title" content="4 Bandara Operasional PT Jagat Indo Perkasa - Ground Handling 24/7" data-id="element-164" />
        <meta property="og:description" content="Melayani 4 bandara strategis di Indonesia: HLP Jakarta, BTW Batulicin, BDJ Banjarbaru, UPG Makassar dengan layanan ground handling profesional 24/7" data-id="element-165" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-166" />
        <meta property="og:locale" content="id_ID" data-id="element-167" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-168" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/airports" data-id="element-169" />
        <meta name="twitter:title" content="Bandara Operasional PT Jagat Indo Perkasa" data-id="element-170" />
        <meta name="twitter:description" content="Melayani 4 bandara strategis di Indonesia dengan layanan ground handling profesional 24/7" data-id="element-171" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-172" />
        <script type="application/ld+json" data-id="element-173">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          name: 'Bandara Operasional PT Jagat Indo Perkasa',
          description: '4 bandara strategis yang dilayani PT Jagat Indo Perkasa di Indonesia',
          itemListElement: airports.map((airport, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'Airport',
              '@id': `https://jagatindoperkasa.id/airports#${airport.code}`,
              name: `Bandara ${airport.name}`,
              iataCode: airport.code,
              address: {
                '@type': 'PostalAddress',
                addressLocality: airport.city,
                addressRegion: airport.region,
                addressCountry: 'ID'
              }
            }
          }))
        })}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-500 to-blue-700 text-white py-16" data-id="element-174">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-176">
            Bandara Operasional
          </h1>
          <p className="text-xl text-sky-100" data-id="element-177">
            Kami melayani 4 bandara strategis di seluruh Indonesia
          </p>
        </div>
      </section>
      {/* Airports Grid */}
      <section className="py-16 bg-white" data-id="element-178">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-180">
            {airports.map((airport, index) => <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-up" style={{
            animationDelay: `${index * 100}ms`
          }} data-id="element-181">
                <div className="relative h-56 overflow-hidden" data-id="element-182">
                  <img src={airport.image} alt={airport.name} className="w-full h-full object-cover" data-id="element-183" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-184"></div>
                  <div className="absolute bottom-4 left-4 right-4" data-id="element-185">
                    <div className="flex items-center justify-between" data-id="element-186">
                      <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg" data-id="element-187">
                        <div className="text-2xl font-bold text-sky-600" data-id="element-188">
                          {airport.code}
                        </div>
                      </div>
                      <div className="bg-sky-600/90 backdrop-blur-sm px-4 py-2 rounded-lg" data-id="element-189">
                        <PlaneIcon className="w-6 h-6 text-white" data-id="element-190" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-6" data-id="element-191">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-192">
                    Bandara {airport.name}
                  </h3>
                  <div className="flex items-center space-x-2 text-gray-600 mb-4" data-id="element-193">
                    <MapPinIcon className="w-5 h-5 text-sky-600" data-id="element-194" />
                    <span className="font-medium" data-id="element-195">
                      {airport.city}, {airport.region}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2 text-green-600" data-id="element-196">
                    <CheckCircleIcon className="w-5 h-5" data-id="element-197" />
                    <span className="text-sm font-medium" data-id="element-198">
                      Operasional Aktif
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Services at Airports */}
      <section className="py-16 bg-gray-50" data-id="element-199">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
          <div className="text-center mb-12" data-id="element-201">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-202">
              Layanan di Setiap Bandara
            </h2>
            <p className="text-lg text-gray-600" data-id="element-203">
              Kami menyediakan layanan ground handling lengkap di semua lokasi
              operasional
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-204">
            {['Ramp Handling', 'Passenger Service', 'Cargo Handling', 'Flight Support & Coordination', 'Cabin Cleaning', 'VIP Protocol Service'].map((service, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow animate-fade-in-up" style={{
            animationDelay: `${index * 100}ms`
          }} data-id="element-205">
                <div className="flex items-center space-x-3" data-id="element-206">
                  <CheckCircleIcon className="w-6 h-6 text-sky-600 flex-shrink-0" data-id="element-207" />
                  <span className="text-gray-900 font-medium" data-id="element-208">{service}</span>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Coverage Stats */}
      <section className="py-16 bg-white" data-id="element-209">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center" data-id="element-211">
            {[{
            number: '4',
            label: 'Bandara Aktif'
          }, {
            number: '3',
            label: 'Provinsi'
          }, {
            number: '24/7',
            label: 'Layanan'
          }, {
            number: '100%',
            label: 'Komitmen'
          }].map((stat, index) => <div key={index} className="animate-fade-in-up transform hover:scale-105 transition-transform duration-300" style={{
            animationDelay: `${index * 150}ms`
          }} data-id="element-212">
                <div className="text-4xl md:text-5xl font-bold text-sky-600 mb-2" data-id="element-213">
                  {stat.number}
                </div>
                <div className="text-gray-600" data-id="element-214">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}